export enum SplitFeatureFlags {
  DD4533_NEW_TOP_LEVEL_NAVIGATION = 'DD-4533-new-top-level-navigation',
  KK_1590_SUNRISE_INTEGRATION = 'KK-1590-sunrise_integration',
  PKP_4866_RESTAGE = 'PKP-4866_Restage',
  KK_3388_EMAIL_VERIFICATION_CODE_FLOWS_PDP = 'KK-3388_Email-Verification-Code-Flows-PDP',
}
